import React, { useEffect, useState } from "react";
import useContract from "../hooks/useContract";
import { useAppKitAccount } from "@reown/appkit/react";

const MyPackages = () => {
  const { contract } = useContract();
  const { address } = useAppKitAccount();
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    const load = async () => {
      const data = await contract.getUserPackages(address);
      setPackages(data);
    };
    if (address) load();
  }, [address]);

  return (
    <div className="p-6 text-white">
      <h2>My Packages</h2>

      {packages.map((p, i) => (
        <div key={i}>Package #{p}</div>
      ))}
    </div>
  );
};

export default MyPackages;